import React from 'react';
import { SCol } from '@avalara/skylab-sdk/react';
import LicensePrepCustomDetails from './license-preparation';
import IossCustomDetails from './ioss';
const customOfferDetails = ({ offerFlow }) => {
    switch (offerFlow) {
        case 'license-preparation':
            return (React.createElement(SCol, { span: '12' },
                React.createElement(LicensePrepCustomDetails, null)));
        case 'ioss':
            return (React.createElement(SCol, { span: '12' },
                React.createElement(IossCustomDetails, null)));
        default:
            return null;
    }
};
export default customOfferDetails;
